<section [style.width]="width" #sectionRef>
  <div
    class="content-wrapper"
    [style.width.px]="sectionRef.offsetWidth - (contentRef.offsetWidth > sectionRef.offsetWidth ? triplets.offsetWidth + 1: 0)"
  >
    <div class="content" #contentRef>
      <ng-content></ng-content>
    </div>
  </div>

  <div
    #triplets
    [hidden]="contentRef.offsetWidth <= sectionRef.offsetWidth"
    class="triplets"
  >
    ...
  </div>
</section>
